__turbopack_context__.v({
  "blok-big-title": "ContainerBlok-module__Ni_TEG__blok-big-title",
  "blok-subtitle": "ContainerBlok-module__Ni_TEG__blok-subtitle",
  "blok-title": "ContainerBlok-module__Ni_TEG__blok-title",
  "container": "ContainerBlok-module__Ni_TEG__container",
});
